/**
 * Operator session — JWT from /auth/google or /auth/dev-login.
 */
export interface AuthUser {
  id: string;
  email: string;
  name: string;
  picture?: string;
  roles: string[];
  provider: string;
}

export interface AuthSession {
  token: string;
  expiresAt?: string;
  user: AuthUser;
}

const TOKEN_KEY = 'enso.auth.token';
const USER_KEY = 'enso.auth.user';
const EXPIRES_KEY = 'enso.auth.expires_at';

export function loadSession(): AuthSession | null {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const rawUser = localStorage.getItem(USER_KEY);
    if (!token || !rawUser) return null;
    const user = JSON.parse(rawUser) as AuthUser;
    if (!user?.email) return null;
    const expiresAt = localStorage.getItem(EXPIRES_KEY) || undefined;
    if (expiresAt) {
      const exp = Date.parse(expiresAt);
      if (!Number.isNaN(exp) && exp < Date.now() - 5_000) {
        clearSession();
        return null;
      }
    }
    return { token, user, expiresAt };
  } catch {
    return null;
  }
}

export function saveSession(session: AuthSession): void {
  localStorage.setItem(TOKEN_KEY, session.token);
  localStorage.setItem(USER_KEY, JSON.stringify(session.user));
  if (session.expiresAt) localStorage.setItem(EXPIRES_KEY, session.expiresAt);
  else localStorage.removeItem(EXPIRES_KEY);
  // Keep collaboration / team identity in sync
  try {
    localStorage.setItem('enso.identity.email', session.user.email);
    localStorage.setItem('enso.identity.name', session.user.name);
  } catch {
    /* ignore */
  }
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXPIRES_KEY);
}

export function getSessionToken(): string {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}
